import { toRoman } from '../../../src/utils/tiptap/customListItemExtension/toRoman.js'
import { listItemConfigurations } from './customListItemExtension/listItemConfigurations'

const listableNodeTypes = ['noteBoardNote']

function formatOrderedNumber(targetStyle, n) {
  if (targetStyle === 'decimal-leading-zero') {
    return `${n.toString().padStart(2, '0')}`
  }
  if (targetStyle === 'decimal' || targetStyle === 'decimal-multilevel') {
    return `${n}`
  }
  if (targetStyle === 'lower-alpha') {
    return `${toAlpha(n - 1).toLowerCase()}`
  }
  if (targetStyle === 'lower-roman') {
    return `${toRoman(n).toLowerCase()}`
  }
  if (targetStyle === 'upper-alpha') {
    return `${toAlpha(n - 1).toUpperCase()}`
  }
  if (targetStyle === 'upper-roman') {
    return `${toRoman(n).toUpperCase()}`
  }
}

function formatUnorderedBullet(text, scale = 1) {
  return `${text}`
}

export function formatCustomListItemSymbol(
  depth,
  itemNoStack,
  checked = true,
  style = 'ordered5',
) {
  let n = itemNoStack[depth] || 0 // Get the item number for the current depth
  n = n + 1 // Convert from 0-based to 1-based numbering
  // console.log('itemNoStack:', itemNoStack)

  const listConfig = listItemConfigurations[style].format
  const depthStyle = listConfig[depth % listConfig.length]
  let result = ''
  switch (depthStyle.type) {
    case 'decimal-multilevel':
      // console.log('Using decimal-multilevel format', itemNoStack)
      result = `${itemNoStack.map((num, idx) => formatOrderedNumber(depthStyle.type, num + 1)).join('.')}`
      break
    case 'decimal':
    case 'decimal-leading-zero':
    case 'lower-alpha':
    case 'lower-roman':
    case 'upper-alpha':
    case 'upper-roman':
      result = `${formatOrderedNumber(depthStyle.type, n)}`
      break
    case 'bullet':
      result = `${formatUnorderedBullet(depthStyle.text)}`
      break
    case 'checkbox':
      result = `${depthStyle[checked ? 'checked' : 'unchecked']}`
      break
    default:
      console.warn(`Unknown list style type: ${depthStyle.type}`)
      result = `${n}` // Fallback to just the number
      break
  }
  const suffix = depthStyle.suffix || ''
  const prefix = depthStyle.prefix || ''
  const scale = depthStyle.scale || 1
  return `${prefix}${result}${suffix}`
}

function toAlpha(n) {
  let str = ''
  while (n >= 0) {
    str = String.fromCharCode((n % 26) + 97) + str
    n = Math.floor(n / 26) - 1
  }
  return str
}
